(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('RubroDialogController', RubroDialogController);

    RubroDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Rubro', 'Comercio'];

    function RubroDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Rubro, Comercio) {
        var vm = this;

        vm.rubro = entity;
        vm.clear = clear;
        vm.save = save;
        vm.comercios = Comercio.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rubro.id !== null) {
                Rubro.update(vm.rubro, onSaveSuccess, onSaveError);
            } else {
                Rubro.save(vm.rubro, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:rubroUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
